import { render } from "./TableSkeletonLoader.vue?vue&type=template&id=44460280&scoped=true"
import script from "./TableSkeletonLoader.vue?vue&type=script&lang=js"
export * from "./TableSkeletonLoader.vue?vue&type=script&lang=js"

import "./TableSkeletonLoader.vue?vue&type=style&index=0&id=44460280&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44460280"]])

export default __exports__